import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../../styles/nexusLayoutFix.css";

export default function PageShell({ title, children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        if (sidebarOpen) {
            document.body.classList.add("nx-sidebar-open");
        } else {
            document.body.classList.remove("nx-sidebar-open");
        }

        return () => {
            document.body.classList.remove("nx-sidebar-open");
        };
    }, [sidebarOpen]);

    return (
        <div className={`nx-app-shell ${sidebarOpen ? "sidebar-open" : ""}`}>
            {sidebarOpen && (
                <button
                    type="button"
                    className="nx-sidebar-backdrop"
                    aria-label="Close navigation"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <div className={`nx-sidebar-frame ${sidebarOpen ? "open" : ""}`}>
                <Sidebar onNavigate={() => setSidebarOpen(false)} />
            </div>

            <main className="nx-main">
                <Topbar
                    title={title}
                    onMenuClick={() => setSidebarOpen(true)}
                />

                <div className="nx-page-body">
                    {children}
                </div>
            </main>
        </div>
    );
}